<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header hint="No. Invoice" :enabled="false" />
            <div class="content">
                <div class="container">
                    <!-- Page title -->
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Laporan Dua Kelinci</h2>
                            </div>

                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto px-0"></div>

                                    <div class="col-auto">
                                        <button class="btn btn-white" v-html="ic('filter') + ' Filter'"
                                            @click="_filter"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading" />
                    <Nodata v-if="!loading && data.length == 0 && isFilter" />
                    <div class="alert alert-info" v-if="!isFilter && !loading">
                        <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data Dua Kelinci
                    </div>

                    <div class="text-center my-6" v-if="!loading && data.length > 0">
                        <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: 0.5" />
                        <h3 class="my-3" v-html="data.length + ' Data'"></h3>

                        <div class="btn-group">
                            <button class="btn btn-outline-primary" @click="_createPdf(dataFilter.reportChoose)" v-if="reportChoose == 'stt'">
                                Export PDF
                            </button>
                            <button class="btn btn-primary" @click="_createExcel(dataFilter.reportChoose)">
                                Export Excel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FormFilter :config.sync="filter.config" :initData="filter.data" :dismiss.sync="filter.dismiss"
            :isSubmit.sync="filter.isSubmit" @submit="filter.action" />
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";

import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
    name: "DKReport",
    components: { FormFilter },

    data() {
        return {
            auth: {},

            filter: {
                config: { view: false, title: null },
                data: null,
                isSubmit: false,
                action: () => { },
            },

            loading: false,
            isFilter: false,
            data: [],

            dataFilter: {
                start_date: this.dateTime("ymd"),
                end_date: this.dateTime("ymd"),
                // status: "all",
                depo: [],
                reportChoose: '',
            },
        };
    },

    mixins: [helper],

    methods: {
        _get() {
            let url = '';
            if (this.dataFilter.reportChoose == 'stt') url = "external_app/dk/report_stt";
            if (this.dataFilter.reportChoose == 'std') url = "external_app/dk/report_std";
            if (this.dataFilter.reportChoose == 'retur') url = "external_app/dk/report_retur";
            this.loading = true;
            this.axios
                .get(url, { params: this.dataFilter })
                .then((res) => {
                    this.loading = false;

                    this.data = [];

                    if (res.data.length != 0) {
                        this.data = res.data.data;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.onError(err);
                });
        },
        _filter() {
            this.filter.config = { view: true, title: "Filter" };
            this.filter.action = (formData) => {
                this.isFilter = true;

                for (const key in formData) {
                    this.dataFilter[key] = formData[key];
                }

                this._get();
            };
        },
        _createPdf(report) {
            if (report == 'stt')  this._createPdfSTT();
        },
        _createPdfSTT() {
            let doc = new jsPDF("p"), user = JSON.parse(localStorage.user);
            let styles = { fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0 };

            // title
            doc.autoTable(this.pdfHeader(""));

            let header = [
                ["Kode", "Nama Barang", "Dus/Pcs", "Sub Total", "Disc", "Ppn", "Net"],
            ],
                temp = [];

            for (let i = 0; i < this.data.length; i++) {
                let data = this.data[i];

                temp.push(data.itemcode);
                temp.push(data.segmen);
                temp.push(data.qty_dus + "/" + data.qty_pcs);
                temp.push(this.ribuan(data.subtotal + "|,2"));
                temp.push(this.ribuan(data.diskon + "|,2"));
                temp.push(this.ribuan(data.ppn + "|,2"));
                temp.push(this.ribuan(data.harganett + "|,2"));

                header.push(temp);
                temp = [];
            }

            styles["cellPadding"] = 2;

            doc.autoTable({
                // body
                theme: "grid",
                styles: styles,
                margin: { top: 10, left: 10, right: 10 },
                body: header,
            });

            this.pdfDownload([doc.output()]);
        },
        _createExcel(report) {
            if (report == 'stt') this._createExcelSTT();
            if (report == 'std') this._createExcelSTD();
            if (report == 'retur') this._createExcelRetur();
        },
        _createExcelSTT() {
            var dataExcel = [];
            for (let i = 0; i < this.data.length; i++) {
                let d = this.data[i];
                dataExcel.push({
                    gudang: d.nama_gudang,
                    outcode: d.outcode,
                    outname: d.outname,
                    address: d.address,
                    kab: d.kab,
                    kecamatan: d.kecamatan,
                    kodepos: d.kodepos,
                    npwp: d.npwp == null || d.npwp == "" ? "" : d.npwp.replaceAll(".", "").replace("-", ""),
                    custtype: d.custtype,
                    typeotl: d.typeotl,
                    distrik: d.distrik,
                    itemcode: d.itemcode,
                    scode: d.scode,
                    groupcode: d.groupcode,
                    brand: d.brand,
                    segmen: d.segmen,
                    satuan: d.satuan,
                    slsmname: d.slsmname,
                    team: d.team,
                    depo: d.depo,
                    qtydus: { v: d.qty_dus, t: "n" },
                    qtypcs: { v: d.qty_pcs, t: "n" },
                    hargatrans: d.hargatrans,
                    volume: { v: d.volume, t: "n" },
                    tahun: d.tahun,
                    bulan: d.bulan,
                    hari: d.hari,
                    transdate: d.transdate,
                    subtotal: d.subtotal,
                    diskon: d.diskon,
                    proposal: d.proposal,
                    ppn: d.ppn,
                    total: d.total,
                    hpp: d.hpp,
                    harga_net: d.harganett,
                    week: d.week,
                    number: d.number,
                    no_pajak: d.no_pajak,
                    berat: d.berat,
                    nopo: d.nopo,
                    status: d.status,
                    ordered_at: d.ordered_at,
                    approved_at: d.approved_at,
                    delivered_at: d.delivered_at,
                    pembayaran: d.pembayaran,
                    NamaPKP: d.namapkp,
                    AlamatPKP: d.alamatpkp,
                    Principal: d.principal,
                    no_ktp: d.no_ktp,
                    nama_ktp: d.nama_ktp,
                    alamat_ktp: d.alamat_ktp,
                    order_qtydus: d.order_qtydus,
                    order_qtypcs: d.order_qtypcs,
                    pending_status: d.pending_status,
                    remark: d.remark,
                });
            }
            this.createExcel(
                {
                    data: dataExcel,
                    filename:
                        "laporan-dk-stt-" +
                        this.dataFilter.start_date +
                        " - " +
                        this.dataFilter.end_date,
                },
                false
            );
        },
        _createExcelSTD() {
            var dataExcel = [];
            for (let i = 0; i < this.data.length; i++) {
                let d = this.data[i];
                dataExcel.push({
                    gudang: d.nama_gudang,
                    supplier: d.supplier,
                    no_pb: d.no_pb,
                    no_do: d.no_do,
                    no_spb: d.no_spb,
                    tgl_kirim: d.tgl_kirim,
                    tgl_datang: d.tgl_datang,
                    tgl_bongkar: d.tgl_bongkar,
                    driver: d.driver,
                    transporter: d.transporter,
                    no_pol_kendaraan: d.no_pol_kendaraan,
                    kode_barang: d.kode_barang,
                    nama_barang: d.nama_barang,
                    segmen: d.segmen,
                    brand: d.brand,
                    satuan: d.satuan,
                    isi: d.isi,
                    qty_dus: d.qty_dus,
                    qty_pcs: d.qty_pcs,
                    harga: d.harga,
                    price_before_tax: d.price_before_tax,
                    subtotal: d.subtotal,
                    ppn: d.ppn,
                    grand_total: d.grand_total,
                    week: d.week,
                    siklus: d.siklus,
                    created_at: d.created_at,
                });
            }
            this.createExcel(
                {
                    data: dataExcel,
                    filename:
                        "laporan-dk-std-" +
                        this.dataFilter.start_date +
                        " - " +
                        this.dataFilter.end_date,
                },
                false
            );
        },
        _createExcelRetur() {
            var dataExcel = [];
            for (let i = 0; i < this.data.length; i++) {
                let d = this.data[i];
                dataExcel.push({
                    'NUMBER': d.number,
                    'Gudang': d.gudang,
                    'SALESRTRD': d.salesrtrd,
                    'ClaimDate': d.claimdate,
                    'CUSTID': d.custid,
                    'CONAME': d.coname,
                    'Address': d.address,
                    'Team': d.team,
                    'Brand': d.brand,
                    'RCat': d.rcat,
                    'StockCode': d.stockcode,
                    'SCode': d.scode,
                    'QtyDus': d.qtydus,
                    'QtyPcs': d.qtypcs,
                    'Volume': d.volume,
                    'Harga0': d.harga0,
                    'NPWP': d.npwp,
                    'Subtotal': d.subtotal,
                    'Disc': d.disc,
                    'Ppn': d.ppn,
                    'TOTAL': d.total,
                    'ExpDate': d.expdate,
                    'Periode': d.periode,
                    'InCarton': d.incarton,
                    'InPcs': d.inpcs,
                    'DPP RETUR PPn': d.dpp,
                    'Depo': d.depo,
                    'Depo2': d.depo2,
                    'KATEGORI': d.kategori,
                    'TAHUN': d.tahun,
                    'BULAN': d.bulan,
                    'WEEKICBP': d.weekicbp,
                    'SIKLUS': d.siklus,
                    'BRAND_NEW': d.brandnew,
                    'SUBBRAND': d.subbrand,
                    'VENDOR': d.vendor,
                    'RCat2': d.rcat2,
                    'no_acc': d.no_acc,
                    'approved_date': d.approved_date,
                    'harga': d.harga,
                    'SEGMEN': d.segmen,
                    'IDRETUR': d.idretur,
                    'TYPERETUR': d.typeretur,
                    'NPR': d.npr,
                    'STATUS': d.status,
                });
            }
            this.createExcel(
                {
                    data: dataExcel,
                    filename:
                        "laporan-dk-retur-" +
                        this.dataFilter.start_date +
                        " - " +
                        this.dataFilter.end_date,
                },
                false
            );
        },
    },

    mounted() {
        this.auth = JSON.parse(localStorage.user);
    },
};
</script>
